// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDCh97gnhC0ppAtUtTgMYNHWx5XZvV91eY",
  authDomain: "buggypeasy-8ef37.firebaseapp.com",
  projectId: "buggypeasy-8ef37",
  storageBucket: "buggypeasy-8ef37.appspot.com",
  messagingSenderId: "40202034301",
  appId: "1:40202034301:web:59ddeacc88cc16f60ca514",
  measurementId: "G-W6W2W40XK5",
  databaseURL:
    "https://buggypeasy-8ef37-default-rtdb.asia-southeast1.firebasedatabase.app",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export default app;
